import Reveal from "@/components/Reveal";
import { trackEvent } from "@/lib/tracking";
import { Mail } from "lucide-react";

export default function EstimatingCTA() {
  return (
    <section id="contact" data-testid="estimating-cta-section" className="bg-rc-bg py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal trackLabel="estimating">
          <div className="bg-white rounded-2xl border border-black/10 shadow-sm p-5 sm:p-8 lg:p-14 text-center max-w-3xl mx-auto">
            <div className="font-mono text-rc-red text-xs uppercase tracking-[0.3em] mb-4">For Estimating</div>
            <h2 className="font-heading font-black text-rc-blue text-[clamp(1.8rem,4vw,3rem)] leading-tight">
              For quotes, bids, or inquiries, please email us.
            </h2>
            <a
              href="mailto:estimating@rangerconstruction.com"
              data-testid="home-estimating-email-link"
              onClick={() => trackEvent("cta_click", { label: "home_estimating_email" })}
              className="mt-8 inline-flex max-w-full items-center justify-center gap-2 bg-rc-red text-white px-3 sm:px-8 py-4 rounded-full font-bold tracking-normal text-[13px] sm:text-sm hover:bg-rc-reddark transition-colors"
            >
              <Mail size={17} className="shrink-0" /><span className="min-w-0"><span className="whitespace-nowrap">estimating@</span><wbr /><span className="whitespace-nowrap">rangerconstruction.com</span></span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
